// extracted by mini-css-extract-plugin
export default {"title":"NewPassword_title__5qfEa","group":"NewPassword_group__uaJRk"};